const HowToViewUserTrainingActivity = () => {
    return(
     <div>
    <ol className="list-decimal list-inside text-grays-dark space-y-4">
      <li>
        Go to{' '}
        <a className="underline text-blue-800" href="http://ctionline.com/">
          CTI Online
        </a>
      </li>
      <li>
        Click <strong>Access your Training</strong> at the top of the page, this will take you to your Training homepage.
         <div className="my-4 border rounded">
          <img src="/images/faqs/Access_Training.png" alt="Courses to start" />
        </div>
      </li>
      <li>
        From your Training Homepage, click the blue square <strong>Reports Menu</strong> on the left side of the screen
        <div className="my-4 rounded">
          <img src="/images/faqs/ReportsMenu.png" alt="Courses to start" />
        </div>
      </li>
      <li>
        Look for the <strong>User Personal Summary</strong> section as shown below and type the name or email address of a user in the box and click <strong>Generate</strong>
        <div className="my-4 rounded">
          <img src="/images/faqs/UserPersonalSummary.png" alt="Courses to start" />
        </div>
      </li>
      <li>
        The User Personal Summary will show an overview of the user’s activity
        <div className="my-4 rounded">
          <img src="/images/faqs/UsersActivity.png" alt="Courses to start" />
        </div>
      </li>
      <li>
        To view more detailed information, select the <strong>Courses or Learning Plans </strong>pages from the list on the left side of the screen
        <div className="my-4 rounded">
          <img src="/images/faqs/Courses.png" alt="Courses to start" />
        </div>
      </li>

     <li>
      To search for another user, type their name or email address into the Select <strong>User</strong> box and click <strong>Generate</strong>
      <div className="my-4 rounded">
          <img src="/images/faqs/AnotherUser.png" alt="Courses to start"/>
        </div>

        Need help with these instructions? please contact {" "}
        <a className="text-blue-800" href="mailto:ctisupport@carquest.com">
          ctisupport@carquest.com
        </a>

     </li>
     
    </ol>
  </div>
    )
}

export default HowToViewUserTrainingActivity